
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/haitian-dictionary",
      function () {
        return require("private-next-pages/haitian-dictionary.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/haitian-dictionary"])
      });
    }
  